import { createFileRoute } from '@tanstack/react-router';

import { BlockCreatePage } from '@/features/content';

export const Route = createFileRoute('/_authed/_active/s/$storeId/content/blocks/new/')({
  staticData: { tours: ['content.block-new'] },
  component: BlockCreatePage,
});
